import React from 'react';

import { Button, ButtonProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
    buttonContainer: {
        position: 'sticky',
        top: '64px',
        background: theme.palette.background.default,
        zIndex: 1000,
        marginBottom: '10px'
    },
    button: {
        margin: theme.spacing(1),
        [theme.breakpoints.down('md')]: {
            minWidth: 32,
            paddingLeft: 8,
            paddingRight: 8,
            '& .MuiButton-startIcon': {
                margin: 0
            }
        }
    },
    buttonText: {
        [theme.breakpoints.down('md')]: {
            display: 'none'
        }
    }
}));

type RespButtonProps = ButtonProps;

const RespButton = (props: RespButtonProps) => {
    const classes = useStyles();
    return (
        <Button {...props} className={classes.button}>
            <span className={classes.buttonText}>{props.children}</span>
        </Button>
    );
};

export default RespButton;
